import * as yup from "yup";
export const VendorSchema = yup.object().shape({
  businessName: yup.string().required("Required"),
  businessAddress: yup.string().required("Required"),
  state: yup.string().required("Required"),
  businessNature: yup.string(),
  notes: yup.string(),
  legalConstitution: yup.string(),
  contactPersonName: yup.string().required("Required"),
  contactPersonPhone: yup
    .string()
    .required("Required")
    .matches(/^\d{10}$/, "Mobile no. must be exactly 10 digits")
    .test(
      "not-all-same",
      "Mobile no. cannot contain all identical digits",
      (value) => !value || !/^(\d)\1{9}$/.test(value) // 0000000000, 1111111111, etc.
    )
    .test("not-sequential", "Mobile no. cannot be sequential", (value) => {
      if (!value) return true;

      const invalid = ["0123456789", "1234567890", "9876543210", "0987654321"];

      return !invalid.includes(value);
    })
    .test(
      "not-repeating-pattern",
      "Mobile no. contains an invalid repeating pattern",
      (value) => {
        if (!value) return true;

        // Reject patterns like:
        // 1234512345
        // 9876598765
        // 1212121212
        // 1231231231
        if (/^(\d{5})\1$/.test(value)) return false; // first 5 repeated
        if (/^(\d{2})\1{4}$/.test(value)) return false; // 12 12 12 12 12
        if (/^(\d{3})\1{2}\d$/.test(value)) return false; // 1231231231
        if (/^(\d{4})\1\d{2}$/.test(value)) return false; // 1234123456

        return true;
      }
    ),
  alternateContactPersonPhone: yup
    .string()
    .matches(/^\d{10}$/, "Mobile no. must be exactly 10 digits")
    .test(
      "not-all-same",
      "Mobile no. cannot contain all identical digits",
      (value) => !value || !/^(\d)\1{9}$/.test(value) // 0000000000, 1111111111, etc.
    )
    .test("not-sequential", "Mobile no. cannot be sequential", (value) => {
      if (!value) return true;

      const invalid = ["0123456789", "1234567890", "9876543210", "0987654321"];

      return !invalid.includes(value);
    })
    .test(
      "not-repeating-pattern",
      "Mobile no. contains an invalid repeating pattern",
      (value) => {
        if (!value) return true;

        // Reject patterns like:
        // 1234512345
        // 9876598765
        // 1212121212
        // 1231231231
        if (/^(\d{5})\1$/.test(value)) return false; // first 5 repeated
        if (/^(\d{2})\1{4}$/.test(value)) return false; // 12 12 12 12 12
        if (/^(\d{3})\1{2}\d$/.test(value)) return false; // 1231231231
        if (/^(\d{4})\1\d{2}$/.test(value)) return false; // 1234123456

        return true;
      }
    ),
  contactPersonEmail: yup.string(),
  panNumber: yup.string(),
  bankName: yup.string().required(),
  bankAccountName: yup.string().required(),
  bankAccountNumber: yup.string().required(),
  generatedBy: yup.string(),
  bankIFSC: yup.string().required(),
  referredBy: yup.string(),
  acceptedPaymentMode: yup.array().of(yup.string()),
  vendorStatus: yup.string(),
  paymentTerm: yup.string(),
  customDeal: yup.string(),
  vendorDealsIn: yup
    .array()
    .required("Required")
    .min(1, "At least one item is required"),

  vendorReg: yup
    .mixed()
    .test("is-valid-size", "Max allowed size is 10MB", (value) => {
      if (value && value.size) {
        return value.size <= 10 * 1024 * 1024;
      } else {
        return true;
      }
    }),
  vendorAgreement: yup
    .mixed()
    .required("Required")
    .test("is-valid-size", "Max allowed size is 10MB", (value) => {
      if (value && value.size) {
        return value.size <= 10 * 1024 * 1024;
      } else {
        return true;
      }
    }),
  vendorSign: yup
    .mixed()
    .test("is-valid-size", "Max allowed size is 10MB", (value) => {
      if (value && value.size) {
        return value.size <= 10 * 1024 * 1024;
      } else {
        return true;
      }
    }),
  vendorBankPassbook: yup
    .mixed()
    .test("is-valid-size", "Max allowed size is 10MB", (value) => {
      if (value && value.size) {
        return value.size <= 10 * 1024 * 1024;
      } else {
        return true;
      }
    }),
  notHaveGST: yup.boolean(),
  gstNumber: yup.string().when("notHaveGST", {
    is: (val) => val === false || val === undefined || val === null,
    then: (s) => s.required("Required"),
  }),
  gstCertificate: yup
    .mixed()
    .when("notHaveGST", {
      is: (val) => val === false || val === undefined || val === null,
      then: (s) => s.required("Required"),
    })
    .test("is-valid-size", "Max allowed size is 10MB", (value) => {
      if (value && value.size) {
        return value.size <= 10 * 1024 * 1024;
      } else {
        return true;
      }
    }),
});
